import { Component, OnInit } from '@angular/core';
import { envSettings } from 'src/common/constant';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  public enviOptions = envSettings;

  constructor() {
    this.enviOptions.headerSectionTitle = '';
    this.enviOptions.headerSectionIcon = null;
  }

  ngOnInit() {
  }

}
